import {Outlet, useLocation} from 'react-router';
import {useEffect} from 'react';
import {motion} from 'framer-motion';

import Footer from 'components/footer';
import {FarmMenuItems} from 'utilities/helper/farmFooterMenuItems';
import useHelmet from 'utilities/hooks/helmet/useHelmet';
import useHiddenBodyScroll from 'utilities/hooks/hiddenBodyScroll/useHiddenBodyScroll';

function FullLayout() {
  useHelmet('حجره');
  const {pathname} = useLocation();
  useHiddenBodyScroll();
  useEffect(() => {
    document.body.className = 'theme-mazrae';
    return () => {
      document.body.className = '';
    };
  }, []);

  return (
    <div className="theme-mazrae">
      <div className=" h-full bg-gray-1">
        <div className="h-screen flex flex-col relative mx-3 bg-white">
          <motion.div
            key={pathname}
            initial={{opacity: 0, x: '100%'}}
            animate={{opacity: 1, x: 0}}
            exit={{opacity: 0, x: '-100%'}}
            transition={{duration: 0.2}}
            className="grow"
          >
            <div className="grow mb-20">
              <Outlet />
            </div>
          </motion.div>
          <Footer menus={FarmMenuItems} isFarm={true} />
        </div>
      </div>
    </div>
  );
}

export default FullLayout;
